const galleryData = [
    {
        original: "img/gallery/gall2019.jpg",
        thumbnail: "img/gallery/gall2019.jpg",
    },
    {
        original: "img/gallery/boatwar_1_2022.jpg",
        thumbnail: "img/gallery/boatwar_1_2022.jpg",
    },
    {
        original: "img/gallery/boatwar_2_2022.jpg",
        thumbnail: "img/gallery/boatwar_2_2022.jpg",
        
    },
    {
        original: "img/gallery/debate_1_2022.jpg",
        thumbnail: "img/gallery/debate_1_2022.jpg",
        
    },
    {
        original: "img/gallery/debate_2_2022.jpg",
        thumbnail: "img/gallery/debate_2_2022.jpg",
        
    },
    {
        original: "img/gallery/team_1_2022.jpg",
        thumbnail: "img/gallery/team_1_2022.jpg",
        
    },
    {
        original: "img/gallery/team_2_2022.jpg",
        thumbnail: "img/gallery/team_2_2022.jpg",
        
    },
    {
        original: "img/gallery/profs_2022.jpg",
        thumbnail: "img/gallery/profs_2022.jpg",
        
    },
    {
        original: "img/gallery/team_3_2022.jpg",
        thumbnail: "img/gallery/team_3_2022.jpg",

    },
    {
        original: "img/gallery/pres_2022.jpg",
        thumbnail: "img/gallery/pres_2022.jpg",
        
    },
    {
        original: "img/gallery/team_4_2022.jpg",
        thumbnail: "img/gallery/team_4_2022.jpg",
        
    },
]

export default galleryData;
